export const MODEL_DATA = 'mdm-model/MODEL_DATA';
